import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_8afee67c from 'nuxt_plugin_plugin_8afee67c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_axios_a60d3d20 from 'nuxt_plugin_axios_a60d3d20' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_54118ae8 from 'nuxt_plugin_workbox_54118ae8' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_46e3359f from 'nuxt_plugin_metaplugin_46e3359f' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4b8adb13 from 'nuxt_plugin_iconplugin_4b8adb13' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_currentUser_0604e187 from 'nuxt_plugin_currentUser_0604e187' // Source: ../../../plugins/currentUser.js (mode: 'all')
import nuxt_plugin_matchMedia_651bcf04 from 'nuxt_plugin_matchMedia_651bcf04' // Source: ../../../plugins/matchMedia.js (mode: 'all')
import nuxt_plugin_queryParams_481ea21a from 'nuxt_plugin_queryParams_481ea21a' // Source: ../../../plugins/queryParams.ts (mode: 'all')
import nuxt_plugin_segmentclient_09292446 from 'nuxt_plugin_segmentclient_09292446' // Source: ../../../plugins/segment.client.js (mode: 'client')
import nuxt_plugin_chartableclient_30c830bc from 'nuxt_plugin_chartableclient_30c830bc' // Source: ../../../plugins/chartable.client.js (mode: 'client')
import nuxt_plugin_growsumoclient_e62fefae from 'nuxt_plugin_growsumoclient_e62fefae' // Source: ../../../plugins/growsumo.client.js (mode: 'client')
import nuxt_plugin_fullStoryclient_d67d60e0 from 'nuxt_plugin_fullStoryclient_d67d60e0' // Source: ../../../plugins/fullStory.client.js (mode: 'client')
import nuxt_plugin_vueCalendlyclient_cfea7eac from 'nuxt_plugin_vueCalendlyclient_cfea7eac' // Source: ../../../plugins/vueCalendly.client.js (mode: 'client')
import nuxt_plugin_vueScrollActive_171db772 from 'nuxt_plugin_vueScrollActive_171db772' // Source: ../../../plugins/vueScrollActive.js (mode: 'all')
import nuxt_plugin_vueYoutube_c6ffb6b4 from 'nuxt_plugin_vueYoutube_c6ffb6b4' // Source: ../../../plugins/vueYoutube.js (mode: 'all')
import nuxt_plugin_vueConfetti_3cee6dfd from 'nuxt_plugin_vueConfetti_3cee6dfd' // Source: ../../../plugins/vueConfetti.js (mode: 'all')
import nuxt_plugin_mountainPixel_7656fd5c from 'nuxt_plugin_mountainPixel_7656fd5c' // Source: ../../../plugins/mountainPixel.js (mode: 'client')
import nuxt_plugin_meta_156e9f58 from 'nuxt_plugin_meta_156e9f58' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bambee is the HR Manager solution for America's small businesses","titleTemplate":"%s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"vmid":"description","hid":"description","name":"description","content":"Bambee is the leading outsourced HR solution for small to large businesses."},{"property":"fb:app_id","content":"1048426768539865"},{"property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"Bambee is the leading outsourced HR solution for small to large businesses"},{"hid":"og:description","vmid":"og:description","property":"og:description","content":"Bambee is the leading outsourced HR solution for small to large businesses."},{"hid":"og:image:type","property":"og:image:type","content":"image\u002Fpng"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preload","as":"style","onload":"this.rel=\"stylesheet\"","href":"https:\u002F\u002Fuse.typekit.net\u002Flnf2zzq.css"},{"rel":"preconnect","href":"https:\u002F\u002Fwidget.intercom.io"},{"rel":"preconnect","href":"https:\u002F\u002Fapi-iam.intercom.io"}],"script":[{"hid":"datadog","src":"https:\u002F\u002Fwww.datadoghq-browser-agent.com\u002Fdatadog-rum-v4.js","type":"text\u002Fjavascript","defer":true},{"hid":"datadog-init","innerHTML":"\n           (function(h,o,u,n,d) {\n            h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n            d=o.createElement(u);d.async=1;d.src=n\n            n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n            })(window,document,'script','https:\u002F\u002Fwww.datadoghq-browser-agent.com\u002Fdatadog-rum-v4.js','DD_RUM')\n            DD_RUM.onReady(function() {\n            DD_RUM.init({\n            clientToken: 'puba5168f9c16cf0a743817eff8706177a6',\n            applicationId: '3e0baca1-6e05-4b55-8c80-a317a6319734',\n            site: 'datadoghq.com',\n            service: 'get',\n            env: 'production',\n            version: '9068662fbc18abcd4a9d63cc89072069f9e6cfd0',\n            sampleRate: 100,\n            sessionReplaySampleRate: 100,\n            tracingSampleRate: 100,\n            trackResources: true,\n            trackLongTasks: true,\n            trackInteractions: true,\n            trackUserInteractions: true,\n            trackFrustrations: true,\n            allowedTracingOrigins: [\u002Fhttps:\\\u002F\\\u002F.*\\.bambee\\.com\u002F],\n            enableExperimentalFeatures: ['clickmap'],\n            silentMultipleInit: true,\n          })\n          DD_RUM && DD_RUM.startSessionReplayRecording();\n        });\n          "}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_8afee67c === 'function') {
    await nuxt_plugin_plugin_8afee67c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_a60d3d20 === 'function') {
    await nuxt_plugin_axios_a60d3d20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_54118ae8 === 'function') {
    await nuxt_plugin_workbox_54118ae8(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_46e3359f === 'function') {
    await nuxt_plugin_metaplugin_46e3359f(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4b8adb13 === 'function') {
    await nuxt_plugin_iconplugin_4b8adb13(app.context, inject)
  }

  if (typeof nuxt_plugin_currentUser_0604e187 === 'function') {
    await nuxt_plugin_currentUser_0604e187(app.context, inject)
  }

  if (typeof nuxt_plugin_matchMedia_651bcf04 === 'function') {
    await nuxt_plugin_matchMedia_651bcf04(app.context, inject)
  }

  if (typeof nuxt_plugin_queryParams_481ea21a === 'function') {
    await nuxt_plugin_queryParams_481ea21a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_segmentclient_09292446 === 'function') {
    await nuxt_plugin_segmentclient_09292446(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chartableclient_30c830bc === 'function') {
    await nuxt_plugin_chartableclient_30c830bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_growsumoclient_e62fefae === 'function') {
    await nuxt_plugin_growsumoclient_e62fefae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fullStoryclient_d67d60e0 === 'function') {
    await nuxt_plugin_fullStoryclient_d67d60e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueCalendlyclient_cfea7eac === 'function') {
    await nuxt_plugin_vueCalendlyclient_cfea7eac(app.context, inject)
  }

  if (typeof nuxt_plugin_vueScrollActive_171db772 === 'function') {
    await nuxt_plugin_vueScrollActive_171db772(app.context, inject)
  }

  if (typeof nuxt_plugin_vueYoutube_c6ffb6b4 === 'function') {
    await nuxt_plugin_vueYoutube_c6ffb6b4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueConfetti_3cee6dfd === 'function') {
    await nuxt_plugin_vueConfetti_3cee6dfd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mountainPixel_7656fd5c === 'function') {
    await nuxt_plugin_mountainPixel_7656fd5c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_156e9f58 === 'function') {
    await nuxt_plugin_meta_156e9f58(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
